import React from 'react';
import PropTypes from 'prop-types';

import { getUsername } from '../../utils/auth';
import { default as AgentAsListItem } from '../Agent/item';
import './styles.scss';

const agents = props => {
  const { agents, profile } = props;

  return (
    <div className="element-box-tp">
      <div className="users-list-w">
        <div className="user-w">
          <div className="user-avatar-w">
            <div className="user-avatar">
              <img
                alt="Placeholder Team"
                src="https://www.gormankelly.com.au/wp-content/uploads/2019/03/Placeholder-Team-Image.jpg"
              />
            </div>
          </div>
          <div className="user-name">
            <h2 className="user-title text-medium">{getUsername()}</h2>
            <div className="user-role">{profile.roleName.toUpperCase()}</div>
          </div>
        </div>
      </div>
      <div className="activity-boxes-w">
        {agents.map((agent, key) => (
          <AgentAsListItem
            name={agent.name}
            businessName={agent.business_name}
            role={agent.role}
            code={agent.code}
            key={key}
          />
        ))}
      </div>
    </div>
  );
};

agents.propTypes = {
  agents: PropTypes.array.isRequired,
  profile: PropTypes.object,
};

export default agents;
